/** Najviše paketa po pošiljci — generator naljepnica pravi najviše ovoliko stranica
 *  („PAKET n/99“), pa ni dialog ne dozvoljava više. */
export const MAX_PACKAGES = 99;

/** Broj paketa iz unosa: cijeli broj od 1 do MAX_PACKAGES, inače `null` (prazno, 0,
 *  decimalno, previše). */
export function parsePackageCount(input: string): number | null {
  const s = input.trim();
  if (!/^\d+$/.test(s)) return null;
  const n = Number(s);
  return n >= 1 && n <= MAX_PACKAGES ? n : null;
}

/** Ograniči broj paketa na dozvoljeni opseg (za dugmad +/- i blur). */
export function clampPackageCount(n: number): number {
  if (!Number.isFinite(n)) return 1;
  return Math.min(MAX_PACKAGES, Math.max(1, Math.floor(n)));
}
